import React from "react";
import { CheckCircle2, Circle, XCircle } from "lucide-react";

const HAPPY_PATH = [
  "Draft",
  "Submitted",
  "Material In Transit",
  "Material Received",
  "Pending Inspection",
  "Approved",
  "Credit Note Pending",
  "Credit Note Uploaded",
  "Closed",
];

function StatusIcon({ kind }) {
  if (kind === "rejected") return <XCircle className="w-5 h-5 text-red-500" />;
  if (kind === "current") return <span className="block w-5 h-5 rounded-full border-2 border-orange-500 bg-orange-500/20" />;
  if (kind === "done") return <CheckCircle2 className="w-5 h-5 text-green-600" />;
  return <Circle className="w-5 h-5 text-slate-300" />;
}

function iconKind({ ev, i, lastIdx, hasHistory, currentIdx }) {
  if (ev.status === "Rejected") return "rejected";
  if (ev.status === "currentStatusMarker") return "current"; // never used, placeholder
  // Note: actual current marker decided in caller.
  if (hasHistory) {
    return i < lastIdx ? "done" : "pending";
  }
  return HAPPY_PATH.indexOf(ev.status) < currentIdx ? "done" : "pending";
}

export function StatusTimeline({ history = [], currentStatus }) {
  const hasHistory = history.length > 0;
  const currentIdx = HAPPY_PATH.indexOf(currentStatus);
  const events = hasHistory ? history : HAPPY_PATH.map((s) => ({ status: s, at: null }));
  const lastIdx = events.length - 1;

  return (
    <ol className="border-l-2 border-slate-200 ml-2 space-y-5">
      {events.map((ev, i) => {
        const isCurrent = ev.status === currentStatus;
        let kind;
        if (isCurrent) {
          kind = "current";
        } else {
          kind = iconKind({ ev, i, lastIdx, hasHistory, currentIdx });
        }
        const key = `${ev.status}-${ev.at || i}`;
        return (
          <li key={key} className="relative pl-6" data-testid={`timeline-${ev.status.toLowerCase().replace(/\s+/g, "-")}`}>
            <span className="absolute -left-[11px] top-0 bg-white">
              <StatusIcon kind={kind} />
            </span>
            <div className={`text-sm ${isCurrent ? "font-semibold text-slate-900" : "text-slate-700"}`}>
              {ev.status}
            </div>
            {ev.at && (
              <div className="text-xs text-slate-500 mt-0.5">
                {new Date(ev.at).toLocaleString()}{ev.by ? ` · by ${ev.by}` : ""}
              </div>
            )}
            {ev.note && <div className="text-xs text-slate-500 mt-0.5">{ev.note}</div>}
          </li>
        );
      })}
    </ol>
  );
}
